import RaiseLabel from './RaiseLabel';
import {IRaiseLabelProps, IRaiseLabelContentProps} from './RaiseLabel.types';

export {RaiseLabel};
export type {IRaiseLabelProps, IRaiseLabelContentProps};
